export default {"src":"https://fishbrain.com/_next/static/media/tennessee.db00f295.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};